import React, { ChangeEvent } from 'react';
import { TextField, styled } from '@mui/material';
import { useTranslate } from '../../hooks';

interface Props {
  label: string;
  value?: string;
  name: string;
  defaultValue?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (e: ChangeEvent) => void;
}

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
}));

const TextInput = (props: Props) => {
  const { dir } = useTranslate();

  return (
    <CustomTextField
      dir={dir}
      variant="outlined"
      disabled={props.disabled}
      focused={props.defaultValue ? true : false}
      {...props}
    />
  );
};

export default TextInput;
